import { find, isNumber } from "lodash";
import { taxList } from "../../../shared/config/taxConfig";

export const formatAmount = (amount) => {
  return amount && isFinite(amount) ? Math.round(amount * 100) / 100 : null;
};
export const calculateTotals = (item) => {
  const {
    price = 0,
    tax_amount = 0,
    is_tax_included = 0,
  } = item;

  let subtotal = 0;
  let tax_total = tax_amount;
  let cgst = 0;
  let sgst = 0;
  let taxable_value = 0;
  let grand_total = 0;

  if (is_tax_included) {
    grand_total = parseFloat(price);
    subtotal = price - tax_amount;
    taxable_value = subtotal;
    cgst = tax_amount / 2;
    sgst = tax_amount / 2;
  } 

  return {
    subtotal,
    tax_total,
    taxable_value,
    cgst_total: cgst,
    sgst_total: sgst,
    total_quantity: item.quantity || 1,
    net_total: subtotal,
    grand_total,
  };
};


export const filterTaxList = (taxList, taxCode) => {
  return taxList.filter((tax) => taxCode.includes(tax.code));
}

export const calculateTotalQuantity = (items) => {
  if (!items || items.length === 0) {
    return 0;
  }

  let totalQuantity = 0;
  items.forEach((item) => {
    if (item.quantity) {
      totalQuantity += item.quantity;
    }
  });

  return totalQuantity;
};